import { createSlice } from "@reduxjs/toolkit";
import { localStorageService } from "../../services";
import { DEFAULT_INFERENCE_MODEL, DEFAULT_INFERENCE_SETTINGS, INFERENCE_MAX_NEW_TOKENS_KEY, INFERENCE_MODEL_KEY, INFERENCE_TEMPERATURE_KEY, INFERENCE_TOPK_KEY, INFERENCE_TOPP_KEY, } from "./constants";
import { SortOptions } from "./userSettings/types";
const initialState = {
    inferenceModel: DEFAULT_INFERENCE_MODEL,
    inferenceMaxNewTokens: DEFAULT_INFERENCE_SETTINGS.maxNewTokens,
    inferenceTemperature: DEFAULT_INFERENCE_SETTINGS.temperature,
    inferenceTopP: DEFAULT_INFERENCE_SETTINGS.topP,
    inferenceTopK: DEFAULT_INFERENCE_SETTINGS.topK,
    myChatbotSortBy: SortOptions.LATEST,
};
const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers: {
        setInferenceModel: (state, action) => {
            const value = action.payload || DEFAULT_INFERENCE_MODEL;
            state.inferenceModel = value;
            localStorageService.setItem(INFERENCE_MODEL_KEY, value);
        },
        setInferenceTemperature: (state, action) => {
            const value = action.payload ?? DEFAULT_INFERENCE_SETTINGS.temperature;
            state.inferenceTemperature = value;
            localStorageService.setItem(INFERENCE_TEMPERATURE_KEY, value.toString());
        },
        setInferenceTopP: (state, action) => {
            const value = action.payload || DEFAULT_INFERENCE_SETTINGS.topP;
            state.inferenceTopP = value;
            localStorageService.setItem(INFERENCE_TOPP_KEY, value.toString());
        },
        setInferenceTopK: (state, action) => {
            const value = action.payload || DEFAULT_INFERENCE_SETTINGS.topK;
            state.inferenceTopK = value;
            localStorageService.setItem(INFERENCE_TOPK_KEY, value.toString());
        },
        setInferenceMaxNewTokens: (state, action) => {
            const value = action.payload || DEFAULT_INFERENCE_SETTINGS.maxNewTokens;
            state.inferenceMaxNewTokens = value;
            localStorageService.setItem(INFERENCE_MAX_NEW_TOKENS_KEY, value.toString());
        },
        setMyChatbotSortBy: (state, action) => {
            state.myChatbotSortBy = action.payload;
        },
    },
});
export const { setInferenceModel, setInferenceTemperature, setInferenceTopP, setInferenceTopK, setInferenceMaxNewTokens, setMyChatbotSortBy, } = settingsSlice.actions;
export default settingsSlice.reducer;
